import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import helperNumber from "../../../helpers/numbers";
function StepsAddCampaigns({ items }) {
  let countCircle = items.length;
  let countLineBetweenCircle = countCircle - 1;
  let countItem = countCircle + countLineBetweenCircle;
  let widthForPerItem = 100 / countItem;

  const generateItem = (items) => {
    const itemsTag = items.map((item, index) => {
      let classLineInvisibleStart;
      let classLineInvisibleEnd;

      let classBgLine = "bg-sliver";
      let tagLinkStep;
      if (item.status === true) {
        classBgLine = "bg-success";
        tagLinkStep = (
          <Link
            to={item.link}
            className="circle-shape-container d-flex justify-content-center"
            style={{ margin: "0px 5px" }}
          >
            <div className={` ${classBgLine} circle-shape`}></div>
          </Link>
        );
      } else {
        tagLinkStep = (
          <div
            className="circle-shape-container d-flex justify-content-center"
            style={{ margin: "0px 5px" }}
          >
            <div className={` ${classBgLine} circle-shape`}></div>
          </div>
        );
      }

      let classBgNextLine = "bg-sliver";
      if (!(index == items.length - 1)) {
        if (items[index + 1].status === true) {
          classBgNextLine = "bg-success";
        }
      }

      if (index == 0) {
        classLineInvisibleStart = "invisible";
      } else if (index == items.length - 1) {
        classLineInvisibleEnd = "invisible";
      }

      return (
        <>
          <div
            key={index}
            style={{ width: widthForPerItem + "%" }}
            className="steps-add-campaigns-circle-item"
          >
            <div className="circle d-flex  align-items-center   ">
              <span
                className={` ${classLineInvisibleStart} ${classBgLine}`}
              ></span>
              {tagLinkStep}
              <span
                className={` ${classLineInvisibleEnd} ${classBgNextLine} `}
              ></span>
            </div>
            <div className="campaigns-name text-center pt-2 ">{item.title}</div>
          </div>
          <div
            style={{ width: widthForPerItem + "%" }}
            className={` ${classLineInvisibleEnd} steps-add-campaigns-line-item d-flex align-items-center`}
          >
            <div className={`   ${classBgNextLine}  w-100`}></div>
          </div>
        </>
      );
    });

    return itemsTag;
  };

  const generateItemMobile = (items) => {
    let tagTitle = "";
    let indexItem = "";

    let tagLinkLastStep = "";
    items.forEach((item, index) => {
      if (item.status == false) {
        tagTitle = items[index - 1].title;
        indexItem = index;

        if (index > 1) {
          let linkLastStep = items[index - 2].link;
          tagLinkLastStep = (
            <Link
              to={linkLastStep}
              className="bg bg-success px-2 rounded-circle"
            >
              <i className="fa fa-angle-right"></i>
            </Link>
          );
        }
      }
    });

    if (tagTitle == "") {
      tagTitle = items[items.length - 1].title;
      indexItem = items.length;
    }

    if (tagLinkLastStep == "" && items[items.length - 1].status == true) {
      let linkLastStep = items[items.length - 2].link;
      tagLinkLastStep = (
        <Link to={linkLastStep} className="bg bg-success px-2 rounded-circle">
          <i className="fa fa-angle-right"></i>
        </Link>
      );
    }

    return (
      <>
        <div className="bg-sky-color py-3 d-flex     justify-content-around ">
          {tagLinkLastStep}
          <div className="badge badge-success">
            مرحله {helperNumber.toPersianNum(indexItem)}
          </div>
          <div>{tagTitle}</div>
        </div>
      </>
    );
  };

  const itemsTag = generateItem(items);
  const itemsTagMobile = generateItemMobile(items);

  return (
    <>
      <div
        id="container-steps-add-campaigns"
        className="py-3 d-none d-md-block"
      >
        <div className="container">
          <div className="row d-flex ">{itemsTag}</div>
        </div>
      </div>
      <div
        id="container-steps-add-campaigns-mobile"
        className="py-2 px-2  d-md-none"
      >
        {itemsTagMobile}
      </div>
    </>
  );
}

export default StepsAddCampaigns;
